// export const config = {
//     mainUrl: 'https://mall.klfspp.com',
//     apiUrl: 'https://mall.klfspp.com/api',
//     imgUrl: 'https://pic.klfspp.com'
// }

// let hostObj = {
//     mainUrl: 'https://mall.klfspp.com',
//     apiUrl: 'https://mall.klfspp.com/api',
//     imgUrl: 'https://pic.klfspp.com'
// }
export default {
    mainUrl: process.env.NODE_ENV === 'development'? '/api' : 'https://mall.klfspp.com',
    apiUrl: 'https://mall.klfspp.com/api',
    imgUrl: 'https://pic.klfspp.com'
}